import { createContext, Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import { getCart } from '../../api/cart'
import { getParsedSessionStorageItem } from '../../js/script'
import { useCommonContext } from './CommonProvider'

const CartContext = createContext<{
  addCart: boolean
  setAddCart: Dispatch<SetStateAction<boolean>>
  cartCount: number
  setCartCount: Dispatch<SetStateAction<number>>
}>({
  addCart: false,
  setAddCart: () => {},
  cartCount: 0,
  setCartCount: () => {},
})

const CartProvider = ({ children }: { children: any }) => {
  const [addCart, setAddCart] = useState<boolean>(false)
  const [cartCount, setCartCount] = useState<number>(0)
  const { hasAccessToken } = useCommonContext()

  useEffect(() => {
    window.addEventListener('onFocus', () => {
      const cartItem = getParsedSessionStorageItem('guestCart')
      if (!hasAccessToken) {
        setCartCount(cartItem?.length)
      } else {
        getCart()
          .then((res) => {
            let con = 0
            res.data.deliveryGroups.map((el: any) => {
              el.orderProducts.map((element: any) => {
                con += element.orderProductOptions.length
              })
            })
            setCartCount(con)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    })
  }, [addCart, location, hasAccessToken])

  useEffect(() => {
    if (!hasAccessToken) {
      const guestCart = getParsedSessionStorageItem('guestCart')
      if (guestCart === null) {
        window.sessionStorage.setItem('guestCart', JSON.stringify([]))
      }
    } else {
      const cart = getParsedSessionStorageItem('cart')
      if (cart === null) {
        window.sessionStorage.setItem('cart', JSON.stringify([]))
      }
    }
  }, [location])

  useEffect(() => {
    const mallNo = getParsedSessionStorageItem('mallProductNo')
    const guestCart = getParsedSessionStorageItem('guestCart')
    if (!mallNo) {
      window.sessionStorage.setItem('mallProductNo', JSON.stringify([]))
    }
    if (!guestCart) {
      window.sessionStorage.setItem('guestCart', JSON.stringify([]))
    }
  }, [])

  useEffect(() => {
    setTimeout(() => {
      const cartItem = getParsedSessionStorageItem('guestCart')
      if (!hasAccessToken) {
        setCartCount(cartItem?.length)
      } else {
        getCart()
          .then((res) => {
            let con = 0
            res.data.deliveryGroups.map((el: any) => {
              el.orderProducts.map((element: any) => {
                con += element.orderProductOptions.length
              })
            })
            setCartCount(con)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }, 300)
  }, [addCart, location, hasAccessToken])

  return (
    <CartContext.Provider
      value={{
        addCart,
        setAddCart,
        cartCount,
        setCartCount,
      }}
    >
      {children}
    </CartContext.Provider>
  )
}

const useCartContext = () => {
  const context = useContext(CartContext)
  if (!context) {
    throw new Error('useCartContext 가 CartProvider 안에서 사용되지 않았습니다.')
  }
  return context
}

export { CartContext, CartProvider, useCartContext }
